import { InjectionToken } from '@angular/core';

export interface FileDeliveryService {
  downloadFile(url: string, fileName: string): Promise<boolean>;
  shareBlob(blob: Blob, fileName: string, title: string): Promise<void>;
  shareImage(dataUrl: string, title: string): Promise<void>;
}

export class BrowserFileDeliveryService implements FileDeliveryService {
  async downloadFile(url: string, fileName: string): Promise<boolean> {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  }

  async shareBlob(blob: Blob, fileName: string, _title: string): Promise<void> {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  }

  async shareImage(dataUrl: string, title: string): Promise<void> {
    const fileName = `${title.replace(/\s+/g, '-').toLowerCase()}-${Date.now()}.png`;
    if (typeof navigator !== 'undefined' && navigator.share) {
      const blob = await fetch(dataUrl).then(r => r.blob());
      const file = new File([blob], fileName, { type: 'image/png' });
      await navigator.share({ title, files: [file] });
    } else {
      const a = document.createElement('a');
      a.href = dataUrl;
      a.download = fileName;
      a.click();
    }
  }
}

export const FILE_DELIVERY_SERVICE = new InjectionToken<FileDeliveryService>(
  'FILE_DELIVERY_SERVICE',
  { providedIn: 'root', factory: () => new BrowserFileDeliveryService() }
);
